import { Component, OnInit, Input } from '@angular/core';
import { CategoryService } from '@app/services/Category/category.service';

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.css']
})
export class SiteMapComponent implements OnInit {
  categories: any;

  constructor(private categoryService: CategoryService) { }

  ngOnInit() {
    this.getCategoryList();
  }

  getCategoryList() {
    this.categoryService.getAll().subscribe({
      next: (data) => {
        this.categories = data;
      }
    });
  }
  
  // Set name for SEO URL 
  getHyphenatedString(limitedTitle :any) {
    let hyphenatedString = limitedTitle
    .replaceAll(" ", "-")
      .toLowerCase();
    return hyphenatedString;
  }
}
